module.exports = __webpack_public_path__ + "img/free.58c37b65.png";